import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Paginated, Pagination } from '@sd-portal/shared/models';
import { LegNoteInformation } from 'libs/pre-flight/feature-aircraft-trip/src/lib/_models/leg-note-information.model';
import { AcknowledgementAlert } from 'libs/shared/audit/src/lib/+models/acknowledgement-alert.model';
import { Observable } from 'rxjs';

@Injectable()
export class AcknowledgementService {
  private readonly baseUrl: string = '/sdapi/pre-flight/acknowledgement/';

  constructor(private readonly http: HttpClient) {}

  getAcknowledgementAlerts(pageParam: Pagination): Observable<Paginated<AcknowledgementAlert>> {
    const url = `${this.baseUrl}getAcknowledgementAlerts`;
    const params = new HttpParams()
      .set('pageSize', pageParam.pageSize.toString())
      .set('pageNumber', pageParam.pageNumber.toString());
    return this.http.get<Paginated<AcknowledgementAlert>>(url, { params });
  }

  getAcknowledgementsByTrip(tripId: Number): Observable<LegNoteInformation[]> {
    const url = `${this.baseUrl}GetCalendarNotificationNotes`;
    const params = new HttpParams().set('tripId', tripId.toString());
    return this.http.get<LegNoteInformation[]>(url, { params });
  }

  hasUnreadAcknowledgementAlerts(): Observable<number> {
    const url = `${this.baseUrl}hasUnReadAcknowledgementAlerts`;
    return this.http.get<number>(url);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  markAcknowledgemntAlertsAsRead(ackIds: number[]): Observable<any> {
    const url = `${this.baseUrl}markAcknowledgemntAlertsAsRead`;
    return this.http.put<number[]>(url, ackIds);
  }
}
